// extracted by mini-css-extract-plugin
export default {"history_container":"AccessHistory_history_container__9B+hx"};